import { Injectable, Optional } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { map } from 'rxjs/operators';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { UtilityService } from './UtilityService';

@Injectable()

export class ErrorMassageValidation {

  static controlContainerstatic = null;

  // tslint:disable-next-line: deprecation
  constructor(private http: Http, @Optional() private controlContainer: ControlContainer
  ) {

    ErrorMassageValidation.controlContainerstatic = this.controlContainer
  }
  url = 'CheckEmailValidation';
  // tslint:disable-next-line: deprecation



  static showerror(FormControlName: string) {
    debugger;
    let form = ErrorMassageValidation.controlContainerstatic.control as FormGroup;
    let control = form.get(FormControlName) as FormControl;
    console.log(control)
    control.setErrors({ 'minlength': true });
    control.markAsTouched()
  }

  //  isEmailRegisterd(Email: string) 
  //  {
  //    let resource:object={
  //      email:Email
  //    };
  //    let body = JSON.stringify(resource);
  //    let headers = new Headers({ 'Content-Type': 'application/json' });
  //    let options = new RequestOptions({ headers: headers });
  //    return this.http.post(environment.baseUrl+this.url,body,options)
  //    .pipe(map(response => response.json()))
  //  }

  getErrorMassageValidation(error: any): string {
    debugger;
    let result: string = ""
    switch (error.key) {
      case "required":
        result = UtilityService.getResourceValue("RequiredValidationKey");
        break;
      case "email":
        result = UtilityService.getResourceValue("EmailValidationKey");
        break;
        case "EmailValidationKey":
          result = UtilityService.getResourceValue("EmailValidationKey");
          break;
      case "pattern":
        result = UtilityService.getResourceValue("NumberValidationKey");
        break;
      case "maxlength":
        result = UtilityService.getResourceValue("MaxLenghtValidationKey") + error.value.requiredLength;
        break;
      case "minlength":
        result = UtilityService.getResourceValue("MinLenghtValidationKey") + error.value.requiredLength;
        break;
      case "min":
        result = UtilityService.getResourceValue("MinValueValidationKey") + error.value.min;
        break;
      case "max":
        result = UtilityService.getResourceValue("MaxValueValidationKey") + error.value.max;

        break;
      case "validatePhoneNumber":
        result = UtilityService.getResourceValue("PhoneNumberValidationKey");
        break;
      case "mask":
        result = UtilityService.getResourceValue("MaskValidationKey") + error.value.requiredMask;
        break;
      case "PasswordComplexityHasNumber":
        result = UtilityService.getResourceValue("PasswordComplexityHasNumber");
        break;
        case "ArabicLetterOnly":
          result = UtilityService.getResourceValue("ArabicLetterOnly");
          break;
          case "EnglishLetterOnly":
          result = UtilityService.getResourceValue("EnglishLetterOnly");
          break;
      case "PasswordComplexityHasCapitalLetter":
        result = UtilityService.getResourceValue("PasswordComplexityHasCapitalLetter");
        break;
      case "PasswordComplexityHasSmallLetter":
        result = UtilityService.getResourceValue("PasswordComplexityHasSmallLetter");
        break;
      case "PasswordComplexityHasSpecialLetter":
        result = UtilityService.getResourceValue("PasswordComplexityHasSpecialLetter");
        break;
        case "MaxWordCountValidationKey":
          result = UtilityService.getResourceValue("MaxWordCountValidationKey")+error.value;
          break;
       case "NewSelectionValidationKey":
            result = UtilityService.getResourceValue("NewSelectionValidationKey");
        break;

        case "MaxFileCountValidationKey":
          result = UtilityService.getResourceValue("MaxFileCountValidationKey")+error.value;
          break;
          case "MinFileCountValidationKey":
            result = UtilityService.getResourceValue("MinFileCountValidationKey")+error.value;
            break;
            case "MaxSizeForAllFilesInMB":
              result = UtilityService.getResourceValue("MaxSizeForAllFilesInMB")+error.value;
              break;

              case "FileMaxSizeInMB":
              result = UtilityService.getResourceValue("FileMaxSizeInMB")+error.value;
              break;

              case "ToolTipTypeError":
              result = UtilityService.getResourceValue("ToolTipTypeError")+error.value;
              break;
          
        
      default:
        break;
    }
    return result;
  }
}